import React, { useState, useEffect } from "react";
import "./bookDetails.css"; // Import your CSS file
import * as bookServices from "../../services/book.services";
import { useParams } from "react-router-dom";
import { ACCESS_TOKEN, BASE_URL, CLIENT_REF } from "../../config/app.config";
import Header from "../../components/header";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Dialog, DialogTitle, DialogContent, DialogActions, Chip } from '@material-ui/core';
import { Link } from "react-router-dom";
const API_URL = `${BASE_URL}books`;
const BookDetails = () => {
  const [book, setBook] = useState({});
  const bookId = useParams().bookId;
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editedBookId, setEditedBookId] = useState(null);
  const [editedBookTitle, setEditedBookTitle] = useState(null);
  const [editedBookDescription, setEditedBookDescription] = useState(null);
  const [editBookLanguage, setEditBookLanguage] = useState(null);
  const [editBookPublishYear, setEditBookPublishYear] = useState(null);
  const [digitalEditionPageNumber, setDigitalEditionPageNumber] = useState(null);

  const [addPageModalOpen, setAddPageModalOpen] = useState(false);
    const [pageNumber, setPageNumber] = useState(null);
    const [targetBook, setTargetBook] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    const [mediaModalOpen, setMediaModalOpen] = useState(false);
    const [audioFile, setAudioFile] = useState([]);
    const [videoFile, setVideoFile] = useState([]);
    const [PDFFile, setPDFFile] = useState(null);
    const [digitalEdition, setDigitalEdition] = useState(null);

    const [voiceName, setVoiceName] = useState('');
    const [videoName, setVideoName] = useState('');
    const [mediaNameModal, setMediaNameModal] = useState(false);

    const [currentPages, setCurrentPages] = useState([]);

    const [addBookThumbnail, setAddBookThumbnail] = useState(null);

    // Add hyperlink state variables
    const [hyperlinkModalOpen, setHyperlinkModalOpen] = useState(false);
    const [hyperlinkName, setHyperlinkName] = useState('');
    const [hyperlinkUrl, setHyperlinkUrl] = useState('');
    const [hyperlinks, setHyperlinks] = useState([]);

    // Desktop build state variables
    const [buildModalOpen, setBuildModalOpen] = useState(false);
    const [building, setBuilding] = useState(false);
    const [buildType, setBuildType] = useState('standard');

  const safeDecodeURI = (uri) => {
    if (!uri) return '';
    try {
      return decodeURIComponent(uri.split('/').pop().replace(/\+/g, " "));
    } catch (e) {
      console.warn('Failed to decode URI:', e);
      return uri;
    }
  };

  const handleEdit = (book) => {
    console.log(book);
    setEditModalOpen(true);
    setEditedBookId(book._id);
    setEditedBookTitle(book.title);
    setEditedBookDescription(book.description);
    setEditBookLanguage(book.language);
    setPDFFile(book.sample);
    setAddBookThumbnail(book.thumbnail);
    setDigitalEdition(book.digitalEdition);
    setEditBookPublishYear(book.publishYear);
    setDigitalEditionPageNumber(book.digitalEditionPageNumber);
}

const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setEditedBookId(null);
    setEditedBookTitle(null);
    setEditedBookDescription(null);
}
const handleSaveEdit = () => {
    bookServices.editBook(editedBookId, editedBookTitle, editedBookDescription, editBookLanguage, PDFFile, undefined, addBookThumbnail, digitalEdition, digitalEditionPageNumber, book.hyperlinks).then((res) => {
        alert('Book updated successfully');
        window.location.reload();
    }).catch((err) => {
        console.log(err);
    })
}

const handleAddPage = (id) => {
  setAddPageModalOpen(true);
  setTargetBook(id);
}



const handleFileUpload = async (e, action) => {
  setIsUploading(true);
  if (e.target.name === 'audio') {
     await bookServices.uploadFile(bookId, e.target.files[0], 'audio').then((res) => {
      if(res.data != null){
      setAudioFile((current) => [...current, {
        name: null,
        url: res.data
      }]);
      setIsUploading(false);
    }
    else{
      alert('Error uploading file');
    }
    }).catch((err) => {
      alert('Error uploading file');
      console.log(err);
    })
  } else if (e.target.name === 'video') {
      await bookServices.uploadFile(bookId, e.target.files[0], 'video').then((res) => {
      if(res.data != null){
      setVideoFile((current) => [...current, {
        name: null,
        url: res.data
      }]);
      setIsUploading(false);
      }
      else{
        alert('Error uploading file');
      }
    }).catch((err) => {
      alert('Error uploading file');
      console.log(err);
    })
  }
  else if (e.target.name === 'pdf' && action === 'sample') {
    await bookServices.uploadFile(bookId, e.target.files[0], 'pdf-sample').then((res) => {
    if(res.data != null){
    setPDFFile(res.data);
    setIsUploading(false);
    }
    else{
      alert('Error uploading file');
    }
    }).catch((err) => {
      alert('Error uploading file');
      console.log(err);
    })
  }
  else if (e.target.name === 'pdf' && action === 'digital') {
    await bookServices.uploadFile(bookId, e.target.files[0], 'pdf-sample').then((res) => {
    if(res.data != null){
    setDigitalEdition(res.data);
    setIsUploading(false);
    }
    else{
      alert('Error uploading file');
    }
    }).catch((err) => {
      alert('Error uploading file');
      console.log(err);
    })
  }
}

const handleThumbnailUpload = async (e) => {
  setIsUploading(true);
  const maxFileSize = 5 * 1024 * 1024; // 5MB
  const fileData = e.target.files[0];
  const allowedExtensions = ['png', 'jpeg', 'jpg'];
  const fileExtension = fileData.name.split('.').pop().toLowerCase();
  if (!allowedExtensions.includes(fileExtension)) {
    alert('Invalid file format. Please choose a PNG or JPEG file.');
    e.target.value = null; // Clear the input
    setIsUploading(false);
    return;
  }
  if (fileData && fileData.size > maxFileSize) {
    // File size exceeds the limit, handle accordingly
    alert('File size exceeds the limit. Please choose a smaller file.');
    // Optionally, clear the input
    e.target.value = null;
    setIsUploading(false);
  } else {
    const file = await bookServices.uploadFile(bookId, e.target.files[0], 'image')
    setAddBookThumbnail(file.data)
    setIsUploading(false);
  }

}
const handleSaveAddPage = () => {
  if(currentPages.includes(Number(pageNumber))){
    alert('Page number already exists');
  }
  else{
  bookServices.addPage(bookId, pageNumber, audioFile, videoFile, [], undefined).then((res) => {
      alert('Page added successfully');
      setAddPageModalOpen(false);
      setPageNumber(null);
      setTargetBook(null);
      window.location.reload();
  }).catch((err) => {
      console.log(err);
  })}
}


const handleUpdatePageMedia = () => {
  bookServices.addPage(bookId, pageNumber, audioFile, videoFile, [], 'addMedia').then((res) => {
      alert('Media added successfully');
      setAddPageModalOpen(false);
      setPageNumber(null);
      setTargetBook(null);
      window.location.reload();
  }).catch((err) => {
      console.log(err);
  })
}

const handleUpdateMediaName = () => {
  bookServices.addPage(bookId, pageNumber, audioFile, videoFile, [], 'updateMediaName').then((res) => {
      alert('Media name updated successfully');
      setMediaNameModal(false);
      setPageNumber(null);
      setTargetBook(null);
      window.location.reload();
  }).catch((err) => {
      console.log(err);
  })
}

const handleClosePageModal = () => {
  setAddPageModalOpen(false);
  setPageNumber(null);
}

const handleAddMedia = (selectedPageNumber,voiceFiles,videoFiles) => {
  setMediaModalOpen(true);
  setPageNumber(selectedPageNumber);
  setAudioFile(voiceFiles ? voiceFiles : []);
  setVideoFile(videoFiles ? videoFiles : []);
}

const handleEditMediaName = (selectedPageNumber, voiceFiles, videoFiles) => {
  setPageNumber(selectedPageNumber);
  setMediaNameModal(true);
  setAudioFile(voiceFiles ? voiceFiles : []);
  setVideoFile(videoFiles ? videoFiles : []);
}

const handleEditMediaAudio = (value, index) => {
  setAudioFile((current) => {
    current[index].name = value;
    return current;
  });
}

const handleEditMediaVideo = (value, index) => {
  setVideoFile((current) => {
    current[index].name = value;
    return current;
  });
}
  

const handleCloseMediaModal = () => {
  setMediaModalOpen(false);
  setPageNumber(null);
  setTargetBook(null);
  setAudioFile([]);
  setVideoFile([]);
}

const handleCloseMediaNameModal = () => {
  setMediaNameModal(false);
  setPageNumber(null);
}

// Add hyperlink handler functions
const handleOpenHyperlinkModal = (selectedPageNumber, pageHyperlinks) => {
  setHyperlinkModalOpen(true);
  setPageNumber(selectedPageNumber);
  setHyperlinks(pageHyperlinks || []);
}

const handleCloseHyperlinkModal = () => {
  setHyperlinkModalOpen(false);
  setHyperlinkName('');
  setHyperlinkUrl('');
  setPageNumber(null);
  setHyperlinks([]);
}

const handleAddHyperlink = () => {
  if (hyperlinkName.trim() && hyperlinkUrl.trim()) {
    const newHyperlink = {
      name: hyperlinkName.trim(),
      url: hyperlinkUrl.trim()
    };
    setHyperlinks([...hyperlinks, newHyperlink]);
    setHyperlinkName('');
    setHyperlinkUrl('');
  }
}

const handleRemoveHyperlink = (index) => {
  const updatedHyperlinks = hyperlinks.filter((_, i) => i !== index);
  setHyperlinks(updatedHyperlinks);
}

const handleSaveHyperlinks = () => {
  bookServices.addPage(bookId, pageNumber, [], [], hyperlinks, 'addMedia').then((res) => {
    alert('Hyperlinks updated successfully');
    setHyperlinkModalOpen(false);
    setPageNumber(null);
    setHyperlinks([]);
    window.location.reload();
  }).catch((err) => {
    console.log(err);
    alert('Error updating hyperlinks');
  });
}

// Desktop build handler functions
const handleBuildDesktop = () => {
  setBuildModalOpen(true);
};

const handleStartBuild = () => {
  setBuilding(true);
  bookServices.buildDesktop(bookId, {
    licenseDays: 270,
    graceDays: 7,
    buildType: buildType
  }).then((res) => {
    const eta = buildType === 'priority' ? '10-15 minutes' : '20-30 minutes';
    alert(`Build started! This will take approximately ${eta}.`);
    setBuildModalOpen(false);
    setBuilding(false);
    window.location.reload();
  }).catch((err) => {
    alert('Failed to start build: ' + (err.message || 'Unknown error'));
    setBuilding(false);
  });
};

const handleCancelBuild = () => {
  if (window.confirm('Are you sure you want to cancel this build?')) {
    bookServices.cancelBuild(bookId).then(() => {
      alert('Build cancelled');
      window.location.reload();
    }).catch((err) => {
      console.error(err);
      alert('Failed to cancel build');
    });
  }
};

const handleDownloadPortable = () => {
  bookServices.getDesktopDownloadUrl(bookId).then((res) => {
    if (res.data && res.data.url) {
      // Open the presigned URL in a new tab to download
      window.open(res.data.url, '_blank');
    } else {
      alert('Download link not available');
    }
  }).catch((err) => {
    console.error(err);
    alert('Failed to get download link');
  });
};

  useEffect(() => {
    bookServices
      .getBookById(bookId)
      .then((res) => {
        res.data.pages.map((page) => {
          setCurrentPages(current => [...current, page.number])
        })
        setBook(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Poll for build status updates
  useEffect(() => {
    if (book?.desktopBuild?.buildStatus === 'building') {
      const interval = setInterval(() => {
        bookServices.getBookById(bookId).then((res) => {
          setBook(res.data);
          if (res.data.desktopBuild?.buildStatus !== 'building') {
            clearInterval(interval);
          }
        }).catch((err) => {
          console.log(err);
        });
      }, 15000); // Poll every 15 seconds
      return () => clearInterval(interval);
    }
  }, [book?.desktopBuild?.buildStatus, bookId]);

  const handleDeleteBookPage = (id, pageId) => {
    bookServices.deleteBookPage(id, pageId).then((res) => {
      console.log(res)
      alert('Page deleted successfully');
      window.location.reload();
  }
  ).catch((err) => {
      console.log(err);
  })
  }

  return (
    <>
      <Header />
      <div className="book-details-container">
        <div className="book-details">
          <div className="book-details__image">
            <img 
              src={book?.thumbnail || "https://media-sea-store.s3.eu-central-1.amazonaws.com/default-thumbnail.png"} 
              alt={book?.title} 
              style={{ width: '150px', height: '200px', objectFit: 'cover', borderRadius: '8px' }}
            />
          </div>
          <div className="book-details__content">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
              <h1 style={{ margin: 0 }}>{book?.title}</h1>
              <Chip 
                label={book?.isActive ? "Active" : "Inactive"} 
                style={{ 
                    backgroundColor: book?.isActive ? '#E8F5E9' : '#FFEBEE', 
                    color: book?.isActive ? '#2E7D32' : '#C62828',
                    fontWeight: 'bold',
                    height: '24px'
                }} 
              />
            </div>
            <p>{book?.description}</p>
            <div style={{ marginTop: '15px' }}>
              <strong>Sample PDF: </strong>
              {book?.sample ? (
                <a href={book.sample} target="_blank" rel="noreferrer">View Sample</a>
              ) : (
                <span style={{ color: 'red' }}>No sample available</span>
              )}
            </div>
            <p style={{ fontSize: '13px', color: 'gray', marginTop: '10px' }}>
              (Click "Edit" to update thumbnail or sample)
            </p>
          </div>
          <div className="book-details-actions">
            <Button className="edit-book-btn" onClick={() => handleEdit(book)}>
              Edit
            </Button>
            <Button
              className="add-page-btn"
              onClick={() => handleAddPage(book?._id)}
            >
              Add Page
            </Button>

            {/* Desktop Build Button */}
            <Button
              className="build-desktop-btn"
              onClick={handleBuildDesktop}
              disabled={book?.desktopBuild?.buildStatus === 'building'}
            >
              {book?.desktopBuild?.buildStatus === 'building'
                ? 'Building...'
                : 'Build Desktop App'}
            </Button>

            {/* Show download if completed */}
            {book?.desktopBuild?.buildStatus === 'completed' && book?.desktopBuild?.downloadUrls?.msiVersion && (
              <Button
                className="download-build-btn"
                component="a"
                href={book.desktopBuild.downloadUrls.msiVersion}
                target="_blank"
              >
                Download Desktop App
              </Button>
            )}

            {/* Show cancel if building */}
            {book?.desktopBuild?.buildStatus === 'building' && (
              <Button
                className="cancel-build-btn"
                onClick={handleCancelBuild}
                color="secondary"
              >
                Cancel Build
              </Button>
            )}

            {/* to be sheet upload  */}
            <Link to={`${book._id}/${book.codeBase}`}>
              <Button className="book-codes-btn">Book Codes</Button>
            </Link>
            <Link to="/books">
              <Button className="back-books-btn">Back to books</Button>
            </Link>
          </div>

          {/* Build Status Display */}
          {book?.desktopBuild && (
            <div className="build-status-section">
              <h3>Desktop Build Status</h3>
              <p>
                Status: <strong>{book.desktopBuild.buildStatus}</strong>
                {book.desktopBuild.buildType && (
                  <span style={{ marginLeft: '10px', fontSize: '12px', color: '#666' }}>
                    ({book.desktopBuild.buildType})
                  </span>
                )}
              </p>
              {book.desktopBuild.buildStatus === 'building' && (
                <p style={{ color: '#1976d2' }}>
                  Building desktop application... This takes 20-30 minutes.
                  <br />
                  You can close this page and come back later.
                </p>
              )}
              {book.desktopBuild.buildStatus === 'completed' && (
                <div>
                  <p style={{ color: 'green' }}>Build completed!</p>
                  {book.desktopBuild.version && (
                    <p>Version: {book.desktopBuild.version}</p>
                  )}
                  {book.desktopBuild.platform && (
                    <p>Platform: {book.desktopBuild.platform}</p>
                  )}
                  <Button
                    className="download-build-btn"
                    onClick={handleDownloadPortable}
                    style={{ marginTop: '10px' }}
                  >
                    Download Portable Version
                  </Button>
                  <p style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                    Download link valid for 3 days
                  </p>
                </div>
              )}
              {book.desktopBuild.buildStatus === 'failed' && (
                <p style={{ color: 'red' }}>
                  Build failed. Please try again.
                </p>
              )}
            </div>
          )}
          <Dialog
            open={editModalOpen}
            onClose={handleCloseEditModal}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Edit Book</DialogTitle>
            <DialogContent>
              <label className="edit-book-label">Book Name</label>
              <input
                autoFocus
                type="text"
                placeholder="Book Title"
                value={editedBookTitle}
                onChange={(e) => setEditedBookTitle(e.target.value)}
                className="edit-book-name"
              />
              <label className="edit-book-label">Book Description</label>
              <textarea
                type="text"
                placeholder="Description"
                value={editedBookDescription}
                onChange={(e) => setEditedBookDescription(e.target.value)}
                className="edit-book-description"
              />
              <label className="edit-book-label">Book Language</label>
              <select
                type="text"
                placeholder="Language"
                value={editBookLanguage}
                onChange={(e) => setEditBookLanguage(e.target.value)}
                className="edit-book-language"
              >
                {["English", "Turkish", "Arabic", "German", "French"].map(
                  (language, index) => (
                    <option key={index} value={language}>
                      {language}
                    </option>
                  )
                )}
              </select>
              <label className="edit-book-label">Book Publish Year</label>
              <input
                autoFocus
                type="text"
                placeholder="Book Publish Year"
                value={editBookPublishYear}
                onChange={(e) => setEditBookPublishYear(e.target.value)}
                className="edit-book-name"
              />
              <label className="voice-file-label">Book Thumbnail</label>
              <input
                type="file"
                name="image"
                className="voice-file-uploader"
                onChange={(e) => handleThumbnailUpload(e)}
              />
              <p style={{ marginBottom: '20px' }}>{book?.thumbnail ? `Current thumbnail: ${safeDecodeURI(book.thumbnail)}` : "No thumbnail uploaded yet"}</p>

              <label className="voice-file-label">Book Sample</label>
              <input
                type="file"
                name="pdf"
                className="voice-file-uploader"
                onChange={(e) => handleFileUpload(e, 'sample')}
              />
              <p style={{ marginBottom: '20px' }}>{book?.sample ? `Current sample: ${safeDecodeURI(book.sample)}` : "No sample uploaded yet"}</p>
              <label className="voice-file-label">Digital Edition</label>
              <input
                type="file"
                name="pdf"
                className="voice-file-uploader"
                onChange={(e) => handleFileUpload(e, 'digital')}
              />
              <label className="edit-book-label">Digital Edition Page Number</label>
              <input
                autoFocus
                type="number"
                placeholder="Digital Edition Page Number"
                value={digitalEditionPageNumber}
                onChange={(e) => {
                  const value = parseInt(e.target.value, 10);
                  const minValue = book?.pages?.length || 1; // Default to 1 if book.pages.length is undefined
                  setDigitalEditionPageNumber(value < minValue ? minValue : value);
                }}
                className="edit-book-name"
                min={book?.pages?.length}
                required={(book?.digitalEdition || digitalEdition) ? true : false}
              />
                <small style={{ color: 'gray' }}>
                  Min value will always stick to defined page numbers, which is {book?.pages?.length}.
                </small>
              <p>{`Current digital edition: ${safeDecodeURI(book?.digitalEdition)}`}</p>
              <label className="voice-file-label">Book Thumbnail</label>
              <input
                type="file"
                name="image"
                className="voice-file-uploader"
                onChange={(e) => handleThumbnailUpload(e)}
              />
              <p>{`Current thumbnail: ${safeDecodeURI(book?.thumbnail)}`}</p>
              <p className="instructions">
                File size should not exceed 5 MB, also this form only accepts
                PNG/JPEG/JPG files
              </p>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseEditModal} color="primary">
                Cancel
              </Button>
              <Button onClick={handleSaveEdit} color="primary">
                Save
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={addPageModalOpen}
            onClose={handleClosePageModal}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Add Book Pages</DialogTitle>
            <DialogContent>
              <label className="edit-book-label">Page Number</label>
              <input
                autoFocus
                type="number"
                placeholder="Page Number"
                value={pageNumber}
                onChange={(e) =>
                  setPageNumber(e.target.value <= 0 ? 1 : e.target.value)
                }
                className="edit-book-name"
                min={1}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClosePageModal} color="primary">
                Cancel
              </Button>
              <Button onClick={handleSaveAddPage} color="primary">
                Save
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={mediaModalOpen}
            onClose={handleCloseMediaModal}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Add Book Media</DialogTitle>
            <DialogContent>
              <label className="voice-file-label">Voice file</label>
              <input
                type="file"
                name="audio"
                className="voice-file-uploader"
                onChange={(e) => handleFileUpload(e, 'voice')}
              />
              <label className="video-file-label">Video file</label>
              <input
                type="file"
                name="video"
                className="video-file-uploader"
                onChange={(e) => handleFileUpload(e, 'video')}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseMediaModal} color="primary">
                Cancel
              </Button>
              <Button onClick={handleUpdatePageMedia} color="primary">
                Save
              </Button>
            </DialogActions>
          </Dialog>

          {isUploading ? (
            <Dialog open={isUploading} aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title">Uploading...</DialogTitle>
              <DialogContent>
                <p>Please wait while the file is being uploaded</p>
              </DialogContent>
            </Dialog>
          ) : (
            <Dialog
              open={mediaNameModal}
              onClose={handleCloseMediaNameModal}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">Edit Media Name</DialogTitle>
              <DialogContent>
                {audioFile?.map((file, index) => {
                  return (
                    <>
                      <div>
                        <label className="voice-file-label">{`Voice File ${index + 1}`}</label>
                        <p>
                        Old Name:{" "}
                          {file.name ? file.name : safeDecodeURI(file.url)}
                        </p>
                        <label>New Name</label>
                        <input
                          type="text"
                          className="file-name-input"
                          onChange={(e) =>
                            handleEditMediaAudio(e.target.value, index)
                          }
                        />
                      </div>
                      <hr />
                      <br />
                    </>
                  );
                })}
                {videoFile?.map((file, index) => {
                  return (
                    <>
                      <div>
                        <label className="video-file-label">{`Video File ${index + 1}`}</label>
                        <p>
                          Old Name:{" "}
                          {file.name ? file.name : safeDecodeURI(file.url)}
                        </p>
                        <label>New Name</label>
                        <input
                          type="text"
                          className="file-name-input"
                          onChange={(e) =>
                            handleEditMediaVideo(e.target.value, index)
                          }
                        />
                      </div>
                      <hr />
                      <br />
                    </>
                  );
                })}
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseMediaNameModal} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleUpdateMediaName} color="primary">
                  Save
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </div>
        
        {/* Add Hyperlink Modal */}
        <Dialog
          open={hyperlinkModalOpen}
          onClose={handleCloseHyperlinkModal}
          aria-labelledby="hyperlink-dialog-title"
          maxWidth="md"
          fullWidth
        >
          <DialogTitle id="hyperlink-dialog-title">Manage Hyperlinks - Page {pageNumber}</DialogTitle>
          <DialogContent>
            <div style={{ marginBottom: '20px' }}>
              <label className="edit-book-label">Hyperlink Name</label>
              <input
                type="text"
                placeholder="Enter hyperlink name"
                value={hyperlinkName}
                onChange={(e) => setHyperlinkName(e.target.value)}
                className="edit-book-name"
                style={{ marginBottom: '10px' }}
              />
              <label className="edit-book-label">Hyperlink URL</label>
              <input
                type="url"
                placeholder="Enter hyperlink URL (e.g., https://example.com)"
                value={hyperlinkUrl}
                onChange={(e) => setHyperlinkUrl(e.target.value)}
                className="edit-book-name"
                style={{ marginBottom: '10px' }}
              />
              <Button 
                onClick={handleAddHyperlink}
                color="primary"
                variant="outlined"
                style={{ marginBottom: '20px' }}
              >
                Add Hyperlink
              </Button>
            </div>
            
            <div>
              <h4>Current Hyperlinks:</h4>
              {hyperlinks.length === 0 ? (
                <p>No hyperlinks added yet.</p>
              ) : (
                <div>
                  {hyperlinks.map((link, index) => (
                    <div key={index} style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      marginBottom: '10px'
                    }}>
                      <div>
                        <strong>{link.name}</strong>
                        <br />
                        <a href={link.url} target="_blank" rel="noopener noreferrer">
                          {link.url}
                        </a>
                      </div>
                      <Button
                        onClick={() => handleRemoveHyperlink(index)}
                        color="secondary"
                        variant="outlined"
                        size="small"
                      >
                        Remove
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseHyperlinkModal} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSaveHyperlinks} color="primary" variant="contained">
              Save Hyperlinks
            </Button>
          </DialogActions>
        </Dialog>

        {/* Build Confirmation Modal */}
        <Dialog
          open={buildModalOpen}
          onClose={() => setBuildModalOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Build Desktop Application</DialogTitle>
          <DialogContent>
            <p>
              This will create a Windows desktop application for <strong>{book?.title}</strong>.
            </p>

            {/* Build Type Selection */}
            <div style={{ margin: '20px 0' }}>
              <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
                Build Type:
              </label>
              <select
                value={buildType}
                onChange={(e) => setBuildType(e.target.value)}
                style={{ width: '100%', padding: '8px', fontSize: '14px' }}
              >
                <option value="standard">Standard (20-30 min, ~$0.02)</option>
                <option value="priority">Priority (10-15 min, ~$0.02)</option>
                <option value="spot">Spot - Cost Saver (20-30 min, ~$0.006)</option>
              </select>

              {buildType === 'priority' && (
                <p style={{ fontSize: '12px', color: '#1976d2', marginTop: '5px' }}>
                  Faster build with 2x CPU power
                </p>
              )}

              {buildType === 'spot' && (
                <p style={{ fontSize: '12px', color: '#4caf50', marginTop: '5px' }}>
                  75% cheaper! May fall back to standard if spot unavailable
                </p>
              )}
            </div>

            <p style={{ fontSize: '12px', color: '#666' }}>
              License: 270 days | Grace period: 7 days
            </p>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setBuildModalOpen(false)}>
              Cancel
            </Button>
            <Button
              onClick={handleStartBuild}
              color="primary"
              variant="contained"
              disabled={building}
            >
              {building ? 'Starting...' : 'Start Build'}
            </Button>
          </DialogActions>
        </Dialog>

        <div className="book-details__table">
          <TableContainer className="admin-table-container" component={Paper}>
            <Table className="admin-table">
              <TableHead>
                <TableRow className="table-header-row">
                  <TableCell className="table-cell" width="5%">
                    Page Number
                  </TableCell>
                  <TableCell className="table-cell" width="20%">
                    Voice File
                  </TableCell>
                  <TableCell className="table-cell" width="20%">
                    Video File
                  </TableCell>
                  <TableCell className="table-cell" width="20%">
                    Hyperlinks
                  </TableCell>
                  <TableCell className="table-cell" width="35%">
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {book?.pages?.map((page) => (
                  <TableRow key={page.number}>
                    <TableCell
                      className="table-cell"
                      component="th"
                      scope="row"
                      width="5%"
                    >
                      {page.number}
                    </TableCell>
                    <TableCell className="table-cell" width="20%">
                      {page.voiceFiles?.map((file, index) => (
                        <p key={index}>                          
                          {file.name ? file.name : safeDecodeURI(file.url)}
                        </p>
                      ))}
                    </TableCell>
                    <TableCell className="table-cell" width="20%">
                      {page.videoFiles?.map((file, index) => (
                        <p key={index}>                          
                          {file.name ? file.name : safeDecodeURI(file.url)}
                        </p>
                      ))}
                    </TableCell>
                    <TableCell className="table-cell" width="20%">
                      {page.hyperlinks?.map((link, index) => (
                        <p key={index}>
                          <a href={link.url} target="_blank" rel="noopener noreferrer">
                            {link.name}
                          </a>
                        </p>
                      ))}
                    </TableCell>
                    <TableCell className="table-cell" width="35%">
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
                        <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                          <Button
                            className="table-action-btn"
                            style={{ flex: '1', minWidth: '120px' }}
                            onClick={() =>
                              handleAddMedia(
                                page.number,
                                page.voiceFiles,
                                page.videoFiles
                              )
                            }
                          >
                            Add Media
                          </Button>
                          <Button
                            className="delete-button"
                            style={{ flex: '1', minWidth: '120px' }}
                            onClick={() => handleDeleteBookPage(book._id, page._id)}
                          >
                            Delete Page
                          </Button>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                          <Button
                            className="table-action-btn"
                            style={{ flex: '1', minWidth: '120px' }}
                            onClick={() =>
                              handleEditMediaName(
                                page.number,
                                page.voiceFiles,
                                page.videoFiles
                              )
                            }
                          >
                            Edit Media Name
                          </Button>
                          <Button
                            className="table-action-btn"
                            style={{ flex: '1', minWidth: '120px' }}
                            onClick={() => handleOpenHyperlinkModal(page.number, page.hyperlinks)}
                          >
                            Add Hyperlink
                          </Button>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default BookDetails;
